<script lang="ts" setup>
import AppMarkdown from 'theme/components/atoms/AppMarkdown.vue';
import SimplePageContainer from 'theme/components/molecules/SimplePageContainer.vue';
import SimplePageHeading from 'theme/components/molecules/SimplePageHeading.vue';

const md = `
## ユーザー様向け注意喚起情報について
このページは、オカネコユーザー様が、安全にオカネコをご利用いただくために注意すべきことを記載しています。

### チャットでの金融商品の募集・勧誘等の禁止
* オカネコのプランナー様との利用規約では、本社オカネコチャット上の金融商品の募集・勧誘を禁止しています。なお、ユーザー様とプランナー様が合意して、ZOOMなど他社のオンラインツール又は現実にお会いしての募集・勧誘は禁止していません。
* 万が一、本社オカネコチャット上で金融商品の募集・勧誘を受けた場合は、本社にご連絡ください。

### 実際に見られた事例
怪しいと思った場合は、国民生活センター、弁護士などの専門家にご相談ください。

* 本社**株式会社400Fの従業員のプロフィールを騙って**、ユーザー様から個人情報等を取得することを目的とした悪質なFacebookなどのアカウントを確認しました。本社は、確認後直ちに警察署に通報いたしました。**本社役職員が、FacebookなどのSNSの個人アカウントを通じて金融商品のご案内、クレジットカード・キャッシュカードなどの情報を聞き出すことは決してございません。**
* 本社**株式会社400Fのコーポレートサイトを模倣**して、ユーザー様から個人情報等を取得することを目的とした悪質なサイトの存在を確認しました。本社は、監督官庁の関東財務局及び管轄の警察署並びにフィッシング対策協議会及び一般社団法人JPCERTコーディネーションセンターに報告・相談を行っています。本社のコーポレートサイトのアドレスは、「[https://400f.jp](https://400f.jp)」ですので、疑わしいサイトについては、アドレスをご確認ください。
<br />
* <b>「暗号資産の勧誘を受けたが取引をしても大丈夫なのか」</b>というお問合せをいただきました。そもそもオカネコチャット上では、金融商品の募集・勧誘を禁止しています。
 仮に、オカネコチャット以外で暗号資産の交換について勧誘を受けた場合は、下記の金融庁のサイトにアップロードされております「暗号資産交換業者登録一覧」などでご確認ください。
[https://www.fsa.go.jp/policy/virtual_currency/index.html](https://www.fsa.go.jp/policy/virtual_currency/index.html)
国民生活センターの注意喚起情報は以下のとおりです。
[https://www.kokusen.go.jp/soudan_topics/data/crypto.html](https://www.kokusen.go.jp/soudan_topics/data/crypto.html)
<br />
* <b>「オフショア投資の勧誘を受けたが取引をしても大丈夫なのか」</b>というお問合せを頂きました。そもそもオカネコチャット上では、金融商品の募集・勧誘を禁止しています。
「オフショア」とは「海外で」を意味します。海外の金融商品は、日本と制度が異なるため、日本の金融商品と比較して利率や課税制度など諸条件で有利であるという説明がなされることがあります。この点を強調して、取引を持ち掛ける事業者などがありますが、そもそも日本で海外の金融商品を購入する場合等では、以下の規制があるのでご注意ください。
例えば、外国証券業者が国内にある者を相手に証券取引行為を行う場合には、国内に支店等の営業拠点を設け、監督当局の登録を受けなければなりません。もっとも、「勧誘」及び「勧誘に類する行為」をすることなく国内居住者から注文を受ける場合は、国内居住者との取引をすることができるとされています。このため、「勧誘ではない」という説明をしながら海外の有価証券等の購入を勧める事業者がいるようです。しかし、 **「外国証券業者に関する命令」において、「勧誘に類する行為」とは、「新聞、雑誌、テレビジョン及びラジオ並びにこれらに類するものによる有価証券に対する投資に関する広告、有価証券に対する投資に関する説明会の開催、口頭、文書又は電話その他の通信手段による有価証券に対する投資に関する情報提供」** が含まれるとされていますので、少しでも怪しいと思った場合は、取引を行わず、国民生活センターなどにご相談することをお勧めします。
その他の金融機関及び詳細は、下記の金融庁のサイトをご覧ください。
[https://www.fsa.go.jp/ordinary/densi/de_003.html](https://www.fsa.go.jp/ordinary/densi/de_003.html)
国民生活センターの注意喚起情報は以下のとおりです。
[https://www.kokusen.go.jp/soudan_now/data/toushi.html](https://www.kokusen.go.jp/soudan_now/data/toushi.html)
`;
</script>
<template>
  <SimplePageContainer :class="$style.container">
    <SimplePageHeading title="ユーザー様向け注意喚起情報" />
    <AppMarkdown :class="$style.container__body" :body="md" />
  </SimplePageContainer>
</template>
<style lang="scss" module>
.container {
  &__body {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}
</style>
